export default __webpack_public_path__ + "static/media/frase.b3bbd917.svg";